export default __webpack_public_path__ + "static/media/007-throat.478d1fb6.svg";